import React from 'react';

/** Local display toggle — does not change stored answers. */
export default function ExerciseAnswerPeekButton({ peeking, onToggle, className = '' }) {
    return (
        <button
            type="button"
            className={`exercise-answer-peek-btn ${className}`.trim()}
            onClick={onToggle}
            aria-pressed={peeking}
        >
            {peeking ? 'Show mine' : 'Show correct'}
        </button>
    );
}
